import React from "react";
import { useQuery, useQueryClient } from "react-query";
import { Table, Button, Space, message, Popconfirm } from "antd";
import axios from "axios";
import AddNegozioModal from "./AddNegozioModal";
import PutNegozioModal from "./PutNegozioModal";

export default function Negozi() {
  const queryClient = useQueryClient();

  const { isLoading, error, data } = useQuery("negozi", () =>
    fetch(`${process.env.REACT_APP_SERVER_URL}/api/negozi/all`).then((res) =>
      res.json()
    )
  );

  if (isLoading) return "Loading...";

  if (error) return "An error has occurred: " + error.message;

  function deleteNegozio(id) {
    axios
      .delete(`${process.env.REACT_APP_SERVER_URL}/api/negozi?id=${id}`)
      .then((response) => {
        if (response.status === 200) {
          console.log(data);
          queryClient.invalidateQueries("negozi");
        }
      })
      .catch((error) => {
        message.error(error.message);
        queryClient.invalidateQueries("negozi");
      });
  }

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "name",
    },
    {
      title: "username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <PutNegozioModal negozio={record} />
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Popconfirm
            title="Are you sure to delete this task?"
            onConfirm={() => deleteNegozio(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger> Rimuovi </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ textAlign: "center", margin: "50px" }}>
        <AddNegozioModal />
      </div>
      <Table
        pagination={true}
        rowKey={(negozio) => negozio.id}
        columns={columns}
        dataSource={data}
      />
    </div>
  );
}
